/* global MEDIA_ROOT */

import React from 'react';

const ArrowRightLarger = props => (
  <img {...props} src={`${MEDIA_ROOT}/icons/icn_arrowrightlarger.svg`} alt="Arrow right" />
);

export default ArrowRightLarger;



// WEBPACK FOOTER //
// ./app/src/components/Iconography/components/ArrowRightLarger/index.jsx